import GUI_Header from "./GUI_Header";
import GUI_InputTextSingle from "./GUI_InputTextSingle";
import GUI_Credit from "./GUI_Credit";
import T from "../TheTool";

function GUIset_nButton(props) {
	var title1 = T.getValue(props.title, "");
	var desc1 = T.getValue(props.desc, "");
	var guiTxt1 = T.getValue(props.guiTxt, "");
	var label1 = T.getValue(props.label1, "Input");
	var isNumOnly = T.getValue(props.isNumOnly, false);
	var label1Align = T.getValue(props.label1Align, "left");
	var width1 = T.getValue(props.width1, 100);
	var buttonList = props.buttonList;
	var butMarginLeft = T.getValue(props.butMarginLeft, "14%");
	var butMarginRight = T.getValue(props.butMarginRight, 0);
	var butMarginTop = T.getValue(props.butMarginTop, 5);
	var marginBeforeButton = T.getValue(props.marginBeforeButton, "2em" );
	var marginAfterButton = T.getValue(props.marginBeforeButton, "3em" );

	function buttons() {
		return buttonList.map((input, index) => {
			var label0 = T.getValue(input.label, "Button " + index);
			var color0 = T.getValue(input.color, "");
			return (
				<div key={index} style={{ display: "flex", marginLeft: butMarginLeft, marginRight: butMarginRight, marginTop: butMarginTop }}>
					<button
						onClick={() => props.buttonClick(index)}
						className="btn btn__primary btn__lg"

						style={{ flex: 1, height: 50 , backgroundColor: color0}}
					>
						{label0}
					</button>
				</div>
			);
		});
	}

	return (
		<div className="todoapp stack-large">
			<GUI_Header title={title1} desc={desc1} />
			<div style={{ marginTop: "3em" }}> </div>
			<GUI_InputTextSingle
				label={label1}
				text1={guiTxt1}
				text1Change={props.guiTxtChange}
				numberOnly={isNumOnly}
				width1={width1}
				fontSize2={24}
				width2={"100%"}
				labelAlign={label1Align}
			/>
			<div style={{ marginTop: marginBeforeButton }}> </div>
			{buttons()}
			<div style={{ marginTop: marginAfterButton}}> </div>
			{props.partResult}
			<GUI_Credit />
		</div>
	);
}
export default GUIset_nButton;
